import React, { useMemo } from 'react';
import { Table } from 'ui-library';
import { useTranslation } from 'react-i18next';
import '../../../../styles/Table-ext.css';

const CasesTable = ({ columns, data, className = '' }) => {
    const { t } = useTranslation();

    const positionsColumns = useMemo(() => (
        columns({ t, currency: 'CHF', data })
    ), []);

    return (
        <Table
            className={`Table--ext ${className}`}
            columns={positionsColumns}
            data={data}
            paging={{
                pageSize: 5,
                total: data?.length ?? 0,
            }}
        />
    );
};

export default CasesTable;
